import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import useSizeDetector from '../hooks/useSizeDetector';

import FooterLogoImg from '../assets/images/footer/logo.png';
import MobileFooterLogoImg from '../assets/images/footer/mobile_logo.svg';
import TermsOfUsePdf from '../assets/pdfs/onmydev_terms_of_use_v1.0.pdf';
import PrivacyPolicyPdf from '../assets/pdfs/onmydev_privacy_policy_v1.1.pdf';

const Footer = () => {
	const { isDesktop, Desktop, Mobile } = useSizeDetector();

	return (
		<Container>
			<Content>
				<Row>
					<FooterLogo src={isDesktop ? FooterLogoImg : MobileFooterLogoImg} />
				</Row>
				<Row>
					<Column>
						<Title>회사정보</Title>
						<Description>
							주식회사 온마이뎁 | 대표자 : 박헌영
							<br />
							경기도 성남시 분당구 황새울로360번길 19, 7층 702호 (서현동, 금화빌딩)
							<br />
							사업자등록번호 : 642-87-02235
							<br />
							통신판매업신고번호 : 2022-성남분당A-0150
						</Description>
						<Copyright>©onmydev Inc. All rights reserved.</Copyright>
					</Column>
					<Column>
						<Title>관련문의</Title>
						<Description>
							이메일 : contact@onmydev.com
						</Description>
					</Column>
					<Column>
						<Desktop>
							<SubTitle>
								<Link to="/company">회사소개</Link>
							</SubTitle>
							<SubTitle>
								<Link to="/recruit">채용</Link>
							</SubTitle>
							<SubTitle>
								<a href={TermsOfUsePdf} target="_blank" rel="noreferrer">
									이용약관
								</a>
							</SubTitle>
							<SubTitle>
								<a href={PrivacyPolicyPdf} target="_blank" rel="noreferrer">
									개인정보처리방침
								</a>
							</SubTitle>
						</Desktop>
						<Mobile>
							<SubTitle>
								<Link to="/company">회사소개</Link>&nbsp;&nbsp;|&nbsp;&nbsp;
								<Link to="/recruit">채용</Link>&nbsp;&nbsp;|&nbsp;&nbsp;
								<a href={TermsOfUsePdf} target="_blank" rel="noreferrer">
									이용약관
								</a>
								&nbsp;&nbsp;|&nbsp;&nbsp;
								<a href={PrivacyPolicyPdf} target="_blank" rel="noreferrer">
									개인정보처리방침
								</a>
							</SubTitle>
						</Mobile>
					</Column>
				</Row>
			</Content>
		</Container>
	);
};

const Container = styled.div`
	width: 100vw;

	display: flex;
	justify-content: center;
	background-color: #4ba4f8;

	@media only screen and (min-width: 768px) {
		height: 388px;
	}

	@media only screen and (max-width: 767.98px) {
		height: 413px;
	}
`;

const Content = styled.div`
	width: 100%;
	max-width: 1352px;
	height: 100%;
	padding: 0 16px;

	display: flex;
	flex-direction: column;

	@media only screen and (max-width: 767.98px) {
		max-width: none;
		padding: 0;
	}
`;

const Row = styled.div`
	display: flex;

	@media only screen and (min-width: 768px) {
		justify-content: space-between;
		& + & {
			margin-top: 40px;
		}
	}

	@media only screen and (max-width: 767.98px) {
		flex-direction: column;
		padding: 0 16px;
	}
`;

const Column = styled.div`
	display: flex;
	flex-direction: column;

	@media only screen and (max-width: 767.98px) {
		margin-top: 30px;
	}
`;

const FooterLogo = styled.img`
	cursor: pointer;

	@media only screen and (min-width: 768px) {
		margin-top: 70px;
		width: 109px;
		height: auto;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 40px;
		width: 68px;
		height: auto;
	}
`;

const Title = styled.span`
	color: white;

	@media only screen and (min-width: 768px) {
		font-size: 16px;
		font-weight: 700;
		line-height: 16px;
	}

	@media only screen and (max-width: 767.98px) {
		font-size: 14px;
		font-weight: 700;
		line-height: 14px;
	}
`;

const Description = styled.span`
	color: white;

	@media only screen and (min-width: 768px) {
		margin-top: 16px;
		font-size: 14px;
		font-weight: 400;
		line-height: 24px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 12px;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
	}
`;

const Copyright = styled.span`
	color: white;

	@media only screen and (min-width: 768px) {
		margin-top: 20px;
		font-size: 14px;
		font-weight: 400;
		line-height: 14px;
	}

	@media only screen and (max-width: 767.98px) {
		margin-top: 11px;
		font-size: 12px;
		font-weight: 400;
		line-height: 12px;
	}
`;

const SubTitle = styled.span`
	color: white;
	cursor: pointer;

	a {
		color: white;
	}

	@media only screen and (min-width: 768px) {
		font-size: 16px;
		font-weight: 600;
		line-height: 16px;

		& + & {
			margin-top: 29px;
		}
	}

	@media only screen and (max-width: 767.98px) {
		font-size: 12px;
		font-weight: 600;
		line-height: 12px;
	}
`;

export default Footer;
